import { Fragment } from 'react'

import ChevronRightSmall from '/react4xp/components/prototype/icons/ChevronRightSmall'

import type { BreadcrumbsProps } from './types'

export default function Breadcrumbs({
	items = [],
	ariaLabel = 'Brødsmulesti',
}: BreadcrumbsProps) {
	if (!items.length) return null

	return (
		<div className="bg-black-950 py-2">
			<div className="container">
				<nav aria-label={ariaLabel}>
					<ol
						className="flex flex-wrap items-end gap-1.5 [&>li]:flex"
						itemScope
						itemType="http://schema.org/BreadcrumbList"
					>
						{items.map((item, i) => (
							<Fragment key={i}>
								{i > 0 && (
									<li aria-hidden="true">
										<ChevronRightSmall className="w-2 h-4 text-brand-500" />
									</li>
								)}
								<li
									itemProp="itemListElement"
									itemScope
									itemType="http://schema.org/ListItem"
								>
									{item.href ? (
										/* h-[1.3125rem] holds the crumb at Figma's 21px — border-b would otherwise add a 22nd px and grow the band to 38 */
										<a
											href={item.href}
											itemProp="item"
											target={item.isExternal ? '_blank' : undefined}
											rel={item.isExternal ? 'noopener noreferrer' : undefined}
											className="caption h-[1.3125rem] max-w-29 truncate text-brand-500 border-b border-brand-800 transition-colors hover:text-pure-white hover:border-brand-200"
										>
											<span itemProp="name">{item.name}</span>
										</a>
									) : (
										/* Figma's "Active page" variant has no max-width, but a real CMS page title can run long — this caps and ellipsizes */
										<span
											itemProp="item"
											aria-current="page"
											className="caption text-brand-500 max-w-29 truncate"
										>
											<span itemProp="name">{item.name}</span>
										</span>
									)}
									<meta itemProp="position" content={String(i + 1)} />
									{!item.href && <meta itemProp="currentpage" content="true" />}
								</li>
							</Fragment>
						))}
					</ol>
				</nav>
			</div>
		</div>
	)
}
